import React, { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import {
  TextInput,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { markets } from "variables/markets";
import uuid from "react-uuid";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
  submitButtonEdit: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabledEdit: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function ContactDialog(props) {
  const { closeModal, refetch, currentContact, contacts, setContacts } = props;

  console.log(contacts);

  const advancedSearchContext = useContext(AdvancedSearchContext);

  const [name, setName] = useState(currentContact?.name || "");
  const [email, setEmail] = useState(currentContact?.email || "");
  const [phone, setPhone] = useState(currentContact?.phone || "");
  const [contactfunction, setContactunction] = useState(currentContact?.contactfunction || "");
  const [address, setAddress] = useState(currentContact?.address || "");

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      name.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name]);

  const handleSubmit = async (event) => {
    if (currentContact)
      updateContact(event);
    else
      createContact(event);
  };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleEmailChange = (event) => { setEmail(event.target.value); };
  const handlePhoneChange = (event) => { setPhone(event.target.value); };
  const handleContactfunctionChange = (event) => { setContactunction(event.target.value); };
  const handleAddressChange = (event) => { setAddress(event.target.value); };

  const createContact = async (event) => {
    let newcontact = {
      uuid:uuid(),
      name,
      email,
      phone,
      contactfunction,
      address
    }
    let newcontactlist = [...contacts];
    newcontactlist.push(newcontact);
    setContacts(newcontactlist);
    closeModal();
  };

  const updateContact = async (event) => {
    let newcontact = {
      uuid:currentContact.uuid,
      name,
      email,
      phone,
      contactfunction,
      address
    }
    let newcontactlist = [...contacts];
    const indexToReplace = newcontactlist.findIndex((x) => x.uuid === currentContact.uuid);
    newcontactlist.splice(indexToReplace, 1, newcontact);
    setContacts(newcontactlist);
    closeModal();
  };
  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                isRequired
                inputTitle={markets.provider.contactname}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={markets.provider.email}
                textInput={email}
                handleTextInputChange={handleEmailChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={markets.provider.phone}
                textInput={phone}
                handleTextInputChange={handlePhoneChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={markets.provider.address}
                textInput={address}
                handleTextInputChange={handleAddressChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={markets.provider.contactfunction}
                textInput={contactfunction}
                handleTextInputChange={handleContactfunctionChange}
              />
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            currentContact ?
              buttonDisabled
                ? classes.submitButtonDisabledEdit
                : classes.submitButtonEdit
              :
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default ContactDialog;
